module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_001.png
// module id = 946
// module chunks = 0